<template>
  <div>
    <AddressForm
      v-for="(address, index) in addresses"
      :key="`address-${index}`"
      v-model="addresses[index]"
      :index="index"
      :membership-uuid="membershipUuid"
      :profile-sharing-is-enabled="profileSharingIsEnabled"
      :errors="errors"
      @remove="removeAddress(index)"
      @add="addAddress"
    />
  </div>
</template>

<script type="text/babel">
import { cloneDeep } from 'lodash'
import AddressForm from 'Membership/Resources/assets/js/components/addresses/AddressForm'
import HasErrors from 'Base/Resources/assets/js/mixins/has-errors'

const defaultAddress = {
  uuid: null,
  is_visible: true,
  type_id: 1,
  address_line_1: '',
  address_line_2: '',
  city: '',
  state: '',
  zip: '',
  country : '',
}

export default {
  name: 'AddressField',
  components: {
    AddressForm,
  },
  mixins: [HasErrors],
  props: {
    value: {
      type: Array,
      required: true,
    },
    membershipUuid: {
      type: String,
      required: false,
      default: 'member',
    },
    profileSharingIsEnabled: {
      type: Boolean,
      required: true,
    },
    defaultCountry: {
      type: String,
      required: false,
      default: 'US',
    },
  },
  computed: {
    addresses() {
      return this.value
    },
  },
  watch: {
    addresses: {
      handler() {
        if (!this.addresses.length) {
          defaultAddress.country = this.defaultCountry.toUpperCase()

          this.$emit('input', [cloneDeep(defaultAddress)])
        }
      },
      immediate: true,
    },
  },
  methods: {
    addAddress() {
      const addresses = cloneDeep(this.addresses)

      addresses.push(cloneDeep(defaultAddress))

      this.$emit('input', addresses)
    },
    removeAddress(index) {
      if (confirm(`Are you sure? (You'll still need to save your profile.)`)) {
        this.addresses.splice(index, 1)
      }
    },
  },
}
</script>
